/**
 * Onboarding field length caps
 *
 * The scripted state-machine's per-field validation (validateField,
 * VALIDATION_ERROR_KEYS, the OnboardingField/ValidationResult types) is
 * retired with the FSM it belonged to — the agentic interview validates
 * server-side (see the profile_extractor post-processor and PUT /me).
 * FIELD_MAX_LENGTHS survives because it's shared beyond onboarding: the
 * profile editor (ProfileEditForm.tsx) and the confirm card's edit inputs
 * both cap free-text fields against this one authoritative source (no
 * duplicated magic numbers per CLAUDE.md §No Hardcoding).
 */

/**
 * Max input lengths, shared by the onboarding confirm card AND the profile
 * editor so the UI `maxLength` guard reads one authoritative source. Inputs
 * without their own entry reuse one of these caps — e.g. the profile editor's
 * role/unit free-text inputs reuse `name`.
 */
export const FIELD_MAX_LENGTHS = {
  name: 100,
  specialisation: 100,
  institution: 200,
  assistant_name: 50,
} as const;
